module.exports = __webpack_public_path__ + "static/img/nav_fix.4c5a8f41.png";